document.addEventListener('DOMContentLoaded', () => {
  setupMobileNav();
  setupStickyHeader();
  //setupProviderSignupRedirects();
  setupProviderRegistrationForm();
  setupCatalog();
  setupQualitySidebar();
  setupCurrentYear();
  setupSiteAnimations();
});

const ELL_PROVIDER_ACCESS_KEY = 'ellProviderAccessGranted:v2';
const ELL_LEGACY_PROVIDER_ACCESS_KEYS = ['ellProviderAccessGranted'];

function hasLocalProviderAccess() {
  try {
    return window.localStorage.getItem(ELL_PROVIDER_ACCESS_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function restoreProviderAccessLinks() {
  document.querySelectorAll('[data-provider-gated-original-href]').forEach((link) => {
    const originalHref = link.getAttribute('data-provider-gated-original-href');
    if (!originalHref) return;

    link.setAttribute('href', originalHref);
    link.removeAttribute('data-provider-gated-original-href');
  });
}

function grantLocalProviderAccess() {
  document.body.dataset.providerApproved = 'true';
  restoreProviderAccessLinks();

  try {
    ELL_LEGACY_PROVIDER_ACCESS_KEYS.forEach((key) => window.localStorage.removeItem(key));
    window.localStorage.setItem(ELL_PROVIDER_ACCESS_KEY, 'true');
    window.sessionStorage.setItem(ELL_PROVIDER_ACCESS_KEY, 'true');
  } catch (error) {
    // Storage can be blocked in some browsers; the data attribute still unlocks this page view.
  }
}

function clearLegacyProviderAccess() {
  try {
    ELL_LEGACY_PROVIDER_ACCESS_KEYS.forEach((key) => {
      window.localStorage.removeItem(key);
      window.sessionStorage.removeItem(key);
    });
  } catch (error) {
    // Ignore storage cleanup failures.
  }
}

function setupProviderSignupRedirects() {
  clearLegacyProviderAccess();

  const catalogUrl = document.body.dataset.catalogUrl || '/collections/all';
  const registrationUrl = document.body.dataset.providerRegistrationUrl || `${catalogUrl}?view=provider-registration`;
  const isProviderApproved = document.body.dataset.providerApproved === 'true' || hasLocalProviderAccess();
  const currentUrl = new URL(window.location.href);
  const view = currentUrl.searchParams.get('view') || '';
  const catalogPath = new URL(catalogUrl, window.location.origin).pathname.replace(/\/$/, '') || '/collections/all';
  const allowedViews = new Set([
    'about-us',
    'quality-safety',
    'provider-registration',
    'provider-info',
    'pricing-order-form',
    'featured-biologic-of-the-month',
  ]);

  if (isProviderApproved) {
    grantLocalProviderAccess();
    return;
  }

  const shouldGateUrl = (url) => {
    const target = new URL(url, window.location.origin);
    const targetPath = target.pathname.replace(/\/$/, '') || '/';
    const targetView = target.searchParams.get('view') || '';
    if (targetView && allowedViews.has(targetView)) return false;
    return targetPath === catalogPath || targetPath.startsWith('/products/');
  };

  if (!allowedViews.has(view) && shouldGateUrl(currentUrl.href)) {
    window.location.replace(registrationUrl);
    return;
  }

  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    if (shouldGateUrl(href)) {
      link.setAttribute('data-provider-gated-original-href', href);
      link.setAttribute('href', registrationUrl);
    }
  });
}

function setupProviderRegistrationForm() {
  const providerPage = document.querySelector('.provider-registration-page');
  if (!(providerPage instanceof HTMLElement)) return;

  const openProductCatalog = () => {
    const catalogUrl = document.body.dataset.catalogUrl || '/collections/all';
    window.location.assign(catalogUrl);
  };

  let redirectTimer;

  const scheduleCatalogOpen = (delay = 1600) => {
    window.clearTimeout(redirectTimer);
    redirectTimer = window.setTimeout(openProductCatalog, delay);
  };

  const handleSubmit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const success = form.querySelector('[data-provider-registration-success]');
    const submitButton = form.querySelector('[type="submit"]');

    if (success instanceof HTMLElement) success.hidden = true;
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.dataset.originalLabel = submitButton.innerHTML || '';
      submitButton.textContent = 'Saving with Shopify...';
    }

    grantLocalProviderAccess();
    scheduleCatalogOpen();
  };

  const isCredentialSelect = (select) => {
    const optionText = Array.from(select.options).map((option) => option.textContent || '').join(' ');
    const labelText = [
      select.getAttribute('aria-label'),
      select.labels ? Array.from(select.labels).map((label) => label.textContent).join(' ') : '',
      select.closest('label')?.textContent,
      select.closest('div')?.textContent,
      select.name,
      select.id,
    ].join(' ');

    const hasProviderCredentialOptions = /\bMD\b/i.test(optionText)
      && /\bDO\b/i.test(optionText)
      && (/\bDDS\b/i.test(optionText) || /MBBS|MBChB/i.test(optionText));

    return /credentials?/i.test(labelText) || hasProviderCredentialOptions;
  };

  const collapseCredentialSelect = (select) => {
    if (!(select instanceof HTMLSelectElement) || select.dataset.ellCredentialsExpanded !== 'true') return;

    select.dataset.ellCredentialsExpanded = 'false';
    select.size = Number(select.dataset.ellOriginalSize || 1);
    select.style.height = select.dataset.ellOriginalHeight || '';
    select.style.maxHeight = select.dataset.ellOriginalMaxHeight || '';
    select.style.overflowY = select.dataset.ellOriginalOverflowY || '';
    select.style.position = select.dataset.ellOriginalPosition || '';
    select.style.zIndex = select.dataset.ellOriginalZIndex || '';
  };

  const expandCredentialSelect = (select) => {
    if (!(select instanceof HTMLSelectElement) || select.dataset.ellCredentialsExpanded === 'true') return;

    select.dataset.ellCredentialsExpanded = 'true';
    select.dataset.ellOriginalSize = select.getAttribute('size') || '1';
    select.dataset.ellOriginalHeight = select.style.height || '';
    select.dataset.ellOriginalMaxHeight = select.style.maxHeight || '';
    select.dataset.ellOriginalOverflowY = select.style.overflowY || '';
    select.dataset.ellOriginalPosition = select.style.position || '';
    select.dataset.ellOriginalZIndex = select.style.zIndex || '';
    select.size = Math.min(Math.max(select.options.length, 8), 12);
    select.style.height = 'auto';
    select.style.maxHeight = '30rem';
    select.style.overflowY = 'auto';
    select.style.position = 'relative';
    select.style.zIndex = '40';
  };

  const enhanceCredentialSelect = (select) => {
    if (!(select instanceof HTMLSelectElement) || select.dataset.ellCredentialsEnhanced === 'true') return;
    if (!isCredentialSelect(select)) return;

    select.dataset.ellCredentialsEnhanced = 'true';
    select.classList.add('ell-credential-native-list');

    select.addEventListener('pointerdown', (event) => {
      if (select.dataset.ellCredentialsExpanded === 'true') return;

      event.preventDefault();
      expandCredentialSelect(select);
      select.focus();
    });

    select.addEventListener('focus', () => {
      if (select.dataset.ellCredentialsExpanded !== 'true') expandCredentialSelect(select);
    });

    select.addEventListener('change', () => {
      window.setTimeout(() => collapseCredentialSelect(select), 120);
    });

    select.addEventListener('blur', () => {
      window.setTimeout(() => collapseCredentialSelect(select), 180);
    });

    select.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        collapseCredentialSelect(select);
        select.blur();
      }
    });
  };

  const getCredentialSelectCandidates = () => {
    const selects = [];
    const collectSelects = (root) => {
      if (!root?.querySelectorAll) return;

      selects.push(...Array.from(root.querySelectorAll('select')));
      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) collectSelects(element.shadowRoot);
      });
    };

    collectSelects(document);

    document.querySelectorAll('iframe').forEach((iframe) => {
      try {
        if (iframe.contentDocument) collectSelects(iframe.contentDocument);
      } catch (error) {
        // Shopify Forms may render cross-origin frames; browser security blocks those from theme scripts.
      }
    });

    return selects;
  };

  const syncCredentialSelects = () => {
    getCredentialSelectCandidates().forEach(enhanceCredentialSelect);
  };

  const appBlocks = providerPage.querySelector('.provider-registration-app-blocks');
  if (appBlocks instanceof HTMLElement) {
    const selectObserver = new MutationObserver(syncCredentialSelects);
    selectObserver.observe(appBlocks, { childList: true, subtree: true });
  }

  const documentObserver = new MutationObserver(syncCredentialSelects);
  documentObserver.observe(document.body, { childList: true, subtree: true });

  const scanStopsAt = Date.now() + 12000;
  const scanTimer = window.setInterval(() => {
    syncCredentialSelects();
    if (Date.now() > scanStopsAt) window.clearInterval(scanTimer);
  }, 500);

  syncCredentialSelects();
  providerPage.addEventListener('submit', handleSubmit, true);
}

function setupStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!(header instanceof HTMLElement)) return;

  const syncHeaderState = () => {
    if (window.scrollY > 8) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };

  syncHeaderState();
  window.addEventListener('scroll', syncHeaderState, { passive: true });
}

function setupMobileNav() {
  const toggle = document.querySelector('[data-nav-toggle]');
  const sheet = document.querySelector('[data-mobile-nav]');
  if (!toggle || !sheet) return;

  const close = sheet.querySelector('[data-nav-close]');
  const backdrop = sheet.querySelector('[data-nav-backdrop]');
  const links = sheet.querySelectorAll('a');
  const desktopQuery = window.matchMedia('(min-width: 1041px)');
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let closeTimer;

  const closeSheet = () => {
    if (!sheet.classList.contains('is-open') && !sheet.classList.contains('is-closing')) return;

    window.clearTimeout(closeTimer);
    sheet.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');

    if (motionQuery.matches) {
      sheet.classList.remove('is-closing');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      return;
    }

    sheet.classList.add('is-closing');
    closeTimer = window.setTimeout(() => {
      sheet.classList.remove('is-closing');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }, 320);
  };

  const openSheet = () => {
    window.clearTimeout(closeTimer);
    sheet.classList.remove('is-closing');
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    document.body.style.overflow = 'hidden';
  };

  const syncForViewport = (event) => {
    if (event.matches) closeSheet();
  };

  toggle.setAttribute('aria-expanded', 'false');
  sheet.setAttribute('aria-hidden', 'true');

  toggle.addEventListener('click', () => {
    if (sheet.classList.contains('is-open')) closeSheet();
    else openSheet();
  });

  [close, backdrop].forEach((element) => {
    if (element) element.addEventListener('click', closeSheet);
  });

  links.forEach((link) => link.addEventListener('click', closeSheet));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSheet();
  });

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', syncForViewport);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(syncForViewport);
  }

  syncForViewport(desktopQuery);
}

function setupCatalog() {
  const catalog = document.querySelector('[data-catalog-root]');
  if (!catalog) return;

  const items = [...catalog.querySelectorAll('[data-lot-item]')];
  const searches = [...catalog.querySelectorAll('[data-catalog-search]')];
  const sort = catalog.querySelector('[data-catalog-sort]');
  const resetButtons = catalog.querySelectorAll('[data-catalog-reset]');
  const count = catalog.querySelector('[data-results-count]');
  const empty = catalog.querySelector('[data-catalog-empty]');
  const pills = catalog.querySelector('[data-filter-pills]');
  const filterButton = catalog.querySelector('[data-filter-toggle]');
  const filterSheet = catalog.querySelector('[data-mobile-filters]');

  const closeFilterSheet = () => {
    if (!filterSheet) return;
    filterSheet.classList.remove('is-open');
    if (filterButton) filterButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  const openFilterSheet = () => {
    if (!filterSheet) return;
    filterSheet.classList.add('is-open');
    if (filterButton) filterButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  if (filterButton && filterSheet) {
    const close = filterSheet.querySelector('[data-filter-close]');
    const backdrop = filterSheet.querySelector('[data-filter-backdrop]');
    filterButton.addEventListener('click', openFilterSheet);
    [close, backdrop].forEach((element) => {
      if (element) element.addEventListener('click', closeFilterSheet);
    });
  }

  const filterNames = ['source', 'volume', 'status', 'cells'];

  const getSelectedValues = (name) =>
    [...catalog.querySelectorAll(`[data-filter-group="${name}"] input:checked`)].map((input) => input.value.toLowerCase());

  const parseCellCount = (value) => {
    const normalized = String(value).replace(/[^0-9.]/g, '');
    return Number.parseFloat(normalized || '0');
  };

  const matchesCellFilter = (itemValue, filters) => {
    if (!filters.length) return true;
    const cellValue = parseCellCount(itemValue);
    return filters.some((filter) => {
      if (filter.includes('10')) return cellValue >= 10;
      if (filter.includes('5')) return cellValue >= 5;
      if (filter.includes('1')) return cellValue >= 1;
      return String(itemValue).toLowerCase().includes(filter);
    });
  };

  const getItemSignature = (item) => ({
    source: (item.dataset.source || '').toLowerCase(),
    volume: (item.dataset.volume || '').toLowerCase(),
    status: (item.dataset.status || '').toLowerCase(),
    cells: item.dataset.cells || '',
    search: (item.dataset.search || '').toLowerCase(),
    sortViability: Number.parseFloat(item.dataset.viabilitySort || '0'),
    sortCells: parseCellCount(item.dataset.cells),
    sortVolume: Number.parseFloat((item.dataset.volume || '').replace(/[^0-9.]/g, '') || '0'),
  });

  const syncMirroredInputs = (event) => {
    const source = event.target;
    if (!(source instanceof HTMLInputElement)) return;
    const key = source.getAttribute('data-sync-key');
    if (!key) return;
    catalog.querySelectorAll(`[data-sync-key="${key}"]`).forEach((input) => {
      if (input !== source) input.checked = source.checked;
    });
    applyFilters();
  };

  catalog.querySelectorAll('[data-sync-key]').forEach((input) => input.addEventListener('change', syncMirroredInputs));

  const applySort = (value) => {
    catalog.querySelectorAll('[data-sort-container]').forEach((wrapper) => {
      const sortable = [...wrapper.querySelectorAll('[data-lot-item]')];
      const visible = sortable.filter((item) => !item.hidden);
      const hidden = sortable.filter((item) => item.hidden);

      visible.sort((a, b) => {
        const one = getItemSignature(a);
        const two = getItemSignature(b);

        switch (value) {
          case 'viability-desc':
            return two.sortViability - one.sortViability;
          case 'cells-desc':
            return two.sortCells - one.sortCells;
          case 'volume-asc':
            return one.sortVolume - two.sortVolume;
          default:
            return 0;
        }
      });

      [...visible, ...hidden].forEach((item) => wrapper.appendChild(item));
    });
  };

  const updatePills = (selected, query) => {
    if (!pills) return;

    const fragments = [];
    if (selected.source.length) fragments.push(`Tissue: ${selected.source.join(', ')}`);
    if (selected.volume.length) fragments.push(`Vol: ${selected.volume.join(', ')}`);
    if (selected.cells.length) fragments.push(`Cells: ${selected.cells.join(', ')}`);
    if (selected.status.length) fragments.push(`Status: ${selected.status.join(', ')}`);
    if (query) fragments.push(`Search: ${query}`);

    pills.innerHTML = '';

    if (!fragments.length) {
      const span = document.createElement('span');
      span.className = 'muted-copy';
      span.textContent = 'Showing all inventory lots';
      pills.appendChild(span);
      return;
    }

    fragments.forEach((label) => {
      const pill = document.createElement('span');
      pill.className = 'filter-pill';
      pill.textContent = label;
      pills.appendChild(pill);
    });
  };

  const getSearchQuery = () => {
    const activeSearch = searches.find((input) => input.value.trim());
    return activeSearch ? activeSearch.value.trim().toLowerCase() : '';
  };

  const syncSearchInputs = (event) => {
    const source = event.target;
    if (!(source instanceof HTMLInputElement)) return;
    searches.forEach((input) => {
      if (input !== source) input.value = source.value;
    });
    applyFilters();
  };

  const applyFilters = () => {
    const selected = Object.fromEntries(filterNames.map((name) => [name, getSelectedValues(name)]));
    const query = getSearchQuery();
    let visibleCount = 0;

    items.forEach((item) => {
      const meta = getItemSignature(item);
      const sourceMatch = !selected.source.length || selected.source.includes(meta.source);
      const volumeMatch = !selected.volume.length || selected.volume.includes(meta.volume);
      const statusMatch = !selected.status.length || selected.status.includes(meta.status);
      const cellsMatch = matchesCellFilter(meta.cells, selected.cells);
      const queryMatch = !query || meta.search.includes(query);
      const isVisible = sourceMatch && volumeMatch && statusMatch && cellsMatch && queryMatch;

      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (sort) applySort(sort.value);
    if (count) count.textContent = `${visibleCount} Result${visibleCount === 1 ? '' : 's'}`;
    if (empty) empty.classList.toggle('is-visible', visibleCount === 0);
    updatePills(selected, query);
  };

  const clearAll = () => {
    catalog.querySelectorAll('[data-filter-group] input').forEach((input) => {
      input.checked = false;
    });
    searches.forEach((input) => {
      input.value = '';
    });
    if (sort) sort.value = 'default';
    applyFilters();
    closeFilterSheet();
  };

  searches.forEach((input) => input.addEventListener('input', syncSearchInputs));
  if (sort) {
    sort.addEventListener('change', () => {
      applySort(sort.value);
      applyFilters();
    });
  }
  resetButtons.forEach((button) => button.addEventListener('click', clearAll));

  applyFilters();
}

function setupQualitySidebar() {
  const qualityPage = document.querySelector('.quality-page');
  if (!qualityPage) return;

  const links = [...qualityPage.querySelectorAll('.quality-sidebar__nav a[href^="#"]')];
  const sections = links
    .map((link) => {
      const id = link.getAttribute('href')?.slice(1);
      const section = id ? document.getElementById(id) : null;
      return section ? { link, section } : null;
    })
    .filter(Boolean);

  if (!sections.length) return;

  const setActive = (activeLink) => {
    links.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };

  const getHeaderOffset = () => {
    const styles = window.getComputedStyle(document.documentElement);
    const headerHeight = Number.parseFloat(styles.getPropertyValue('--ell-header-height')) || 76;
    return headerHeight + 48;
  };

  const updateActiveFromScroll = () => {
    let active = sections[0];
    const activationLine = getHeaderOffset();

    sections.forEach((entry) => {
      if (entry.section.getBoundingClientRect().top <= activationLine) active = entry;
    });

    setActive(active.link);
  };

  const scheduleUpdate = () => window.requestAnimationFrame(updateActiveFromScroll);

  links.forEach((link) => {
    link.addEventListener('click', () => {
      setActive(link);
      window.setTimeout(updateActiveFromScroll, 120);
    });
  });

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('hashchange', () => window.setTimeout(updateActiveFromScroll, 120));
  window.addEventListener('load', updateActiveFromScroll);
  updateActiveFromScroll();
  window.setTimeout(updateActiveFromScroll, 120);
}

function setupCurrentYear() {
  document.querySelectorAll('[data-current-year]').forEach((element) => {
    element.textContent = String(new Date().getFullYear());
  });
}

function setupSiteAnimations() {
  const root = document.documentElement;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionGroups = [
    { selector: '.home-hero__copy > .eyebrow, .home-hero__copy > .display-title, .home-hero__copy > .lead-copy', variant: 'motion-hero-copy', step: 110 },
    { selector: '.home-hero__actions .ell-button', variant: 'motion-hero-action', step: 95 },
    { selector: '.cell-visual', variant: 'motion-hero-visual' },
    { selector: '.trust-badge', variant: 'motion-fade-up', step: 70 },
    { selector: '.solutions-editorial__intro > *, .solutions-article', variant: 'motion-fade-up', step: 90 },
    { selector: '.solution-card', variant: 'motion-fade-up', step: 110 },
    { selector: '.feature-card', variant: 'motion-fade-up', step: 95 },
    { selector: '.collection-hero > *', variant: 'motion-fade-up', step: 90 },
    { selector: '.filters-panel > *, .filters-panel__card, .table-shell, .catalog-mobile-card', variant: 'motion-fade-up', step: 80 },
    { selector: '.collection-product-card, .search-result-card', variant: 'motion-fade-up', step: 75 },
    { selector: '.detail-main > *, .detail-panel', variant: 'motion-fade-up', step: 90 },
    { selector: '.quality-sidebar, .quality-page__hero .quality-content-section, .quality-main > .quality-content-section', variant: 'motion-fade-up', step: 95 },
    { selector: '.cert-card, .timeline-item, .resource-card', variant: 'motion-fade-up', step: 75 },
    { selector: '.procurement-page__hero > *, .procurement-steps > *, .procurement-layout > *', variant: 'motion-fade-up', step: 85 },
    { selector: '.contact-layout > *, .contact-support-grid > *', variant: 'motion-fade-up', step: 90 },
    { selector: '.team-page__intro > *, .team-card', variant: 'motion-fade-up', step: 100 },
    { selector: '.cart-shell, .cart-summary-box, .cart-items > *', variant: 'motion-fade-up', step: 80 },
    { selector: '.site-footer__brand, .site-footer .footer-links > *, .footer-bottom', variant: 'motion-fade-up', step: 70 },
    { selector: '.error-shell', variant: 'motion-fade-up', step: 90 },
  ];

  let observer;

  const collectTargets = () => {
    const seen = new Set();
    const targets = [];

    motionGroups.forEach((group) => {
      document.querySelectorAll(group.selector).forEach((element, index) => {
        if (!(element instanceof HTMLElement) || seen.has(element)) return;
        if (element.closest('[hidden], .mobile-sheet, .mobile-filter-sheet')) return;

        seen.add(element);
        element.classList.add('motion-reveal', group.variant);
        element.style.setProperty('--motion-delay', `${(group.step || 80) * index}ms`);
        targets.push(element);
      });
    });

    return targets;
  };

  const revealImmediately = (targets) => {
    targets.forEach((element) => element.classList.add('is-visible'));
  };

  const disconnectObserver = () => {
    if (!observer) return;
    observer.disconnect();
    observer = null;
  };

  const syncMotion = () => {
    const targets = collectTargets();
    disconnectObserver();

    if (prefersReducedMotion.matches) {
      root.classList.remove('motion-enabled');
      root.classList.add('motion-reduce');
      revealImmediately(targets);
      return;
    }

    root.classList.remove('motion-reduce');
    root.classList.add('motion-enabled');

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer?.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    targets.forEach((element) => {
      element.classList.remove('is-visible');
      observer.observe(element);
    });
  };

  if (typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', syncMotion);
  } else if (typeof prefersReducedMotion.addListener === 'function') {
    prefersReducedMotion.addListener(syncMotion);
  }

  syncMotion();
}
